export const routes = {
    LandingPage: "/",
    Terms: "/terms",
    Privacy: "/privacy",
    Imprint: "/imprint",
    CertificateValidator: "/:orga_slug/:certificate_slug",
    YourCertificate: "/:orga_slug/:certificate_slug/badge",
};
